export interface Comic {
  id: string;
  title: string;
  author: string;
  category: '韩漫' | '日漫' | '国漫';
  genres: string[];
  coverImage: string;
  description: string;
  fullDescription: string;
  rating: number;
  status: '连载中' | '已完结';
  totalChapters: number;
  views: number;
  updatedAt: string;
  featured?: boolean;
  tags: string[];
}

export const categories: { key: string; label: string; description: string }[] = [
  { key: '韩漫', label: '韩漫', description: '韩国漫画以其精致的画风和独特的叙事风格深受读者喜爱' },
  { key: '日漫', label: '日漫', description: '日本漫画拥有最丰富的题材和最成熟的产业体系' },
  { key: '国漫', label: '国漫', description: '国产漫画近年迅速崛起，涌现大量优质原创作品' },
];

export const genres: { key: string; label: string }[] = [
  { key: '恋爱', label: '恋爱' },
  { key: '奇幻', label: '奇幻' },
  { key: '热血', label: '热血' },
  { key: '悬疑', label: '悬疑' },
  { key: '搞笑', label: '搞笑' },
  { key: '都市', label: '都市' },
  { key: '古风', label: '古风' },
  { key: '校园', label: '校园' },
  { key: '冒险', label: '冒险' },
  { key: '治愈', label: '治愈' },
  { key: '科幻', label: '科幻' },
  { key: '动作', label: '动作' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '韩漫',
    genres: ['热血', '奇幻', '动作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20dark%20fantasy%20hunter%20action%20comic%20cover%20art%2C%20dynamic%20pose%20character%20with%20glowing%20eyes%2C%20purple%20and%20black%20atmosphere%2C%20dramatic%20lighting%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '十多年前，世界各地突然出现连接异次元与现世的"传送门"，觉醒者应运而生。被称为"人类最弱兵器"的E级猎人程肖宇，在一次地下城探索中濒死之际，获得了神秘的"升级系统"……',
    fullDescription: '十多年前，世界各地突然出现连接异次元与现世的"传送门"，在此之中觉醒超能力的人类被称为"觉醒者"。他们利用这些能力，在传送门中讨伐地下城的怪物以获取报酬。被称为"人类最弱兵器"的E级猎人程肖宇，在一次D级地下城探索中，整个团队几乎全军覆没。濒死之际，一个神秘的选择窗口出现在他眼前——「您已成为玩家」。获得系统"升级"能力的程肖宇，踏上了从最弱到最强的逆袭之路。这是近年来最火爆的韩漫之一，画风精美、战斗场面震撼，剧情节奏紧凑，角色成长线令人欲罢不能。',
    rating: 9.7,
    status: '已完结',
    totalChapters: 179,
    views: 12890000,
    updatedAt: '2024-12-15',
    featured: true,
    tags: ['超人气', '动作', '升级流', '逆袭'],
  },
  {
    id: 'comic-2',
    title: '咒术回战',
    author: '芥见下下',
    category: '日漫',
    genres: ['热血', '奇幻', '动作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20jujutsu%20kaisen%20style%20supernatural%20action%20cover%20art%2C%20character%20with%20dark%20uniform%20and%20mask%2C%20cursed%20energy%20effects%2C%20dynamic%20composition%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '高中生虎杖悠仁在遭遇诅咒后，吞下了宿傩的手指，从此踏上了咒术师的道路。与伙伴们一起对抗诅咒的精彩故事，充满华丽战斗与深刻友情。',
    fullDescription: '高中生虎杖悠仁拥有超乎常人的体能。某天，他为了从"诅咒"危机中解救学长学姐，吞下了被封印的特级咒物——两面宿傩的手指，自此成为了宿傩的容器。为了收集散落各地的宿傩手指，虎杖加入了东京都立咒术高等专门学校，与伏黑惠、钉崎野蔷薇等伙伴一起，踏上了咒术师的修行之路。这是一部将传统日式妖怪文化与现代战斗完美融合的现象级作品，人物塑造极具魅力，战斗系统设计精巧，情感刻画深入人心。',
    rating: 9.5,
    status: '连载中',
    totalChapters: 271,
    views: 15600000,
    updatedAt: '2025-01-20',
    featured: true,
    tags: ['现象级', '战斗', '友情', '咒术'],
  },
  {
    id: 'comic-3',
    title: '狐妖小红娘',
    author: '小新',
    category: '国漫',
    genres: ['恋爱', '奇幻', '古风'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20fox%20spirit%20matchmaker%20style%20romance%20fantasy%20cover%20art%2C%20beautiful%20fox%20girl%20in%20traditional%20red%20hanfu%2C%20ancient%20Chinese%20aesthetic%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '在人妖共存的世界里，涂山狐妖一族以红线仙的身份为人与妖牵线搭桥。涂山苏苏与道士白月初的相遇，揭开了一段跨越前世今生的浪漫奇幻之旅。',
    fullDescription: '世上有人有妖，妖会与人相恋。妖寿命千万年，人的寿命有限。人死了，妖还活着。人会投胎转世，但投胎以后，不记得上辈子的爱。妖若痴情，就去找狐妖"购买"一项服务——让投胎转世的人，回忆起前世的记忆和爱。涂山狐妖一族，正是这世间最为著名的"红线仙"。涂山苏苏是一只可爱的小狐妖，与道士白月初意外相遇后，两人开始了一段段帮助他人寻回前世之缘的冒险。这部国漫以独特的设定和细腻的情感描绘，成为了国产漫画的标杆之作。',
    rating: 9.3,
    status: '连载中',
    totalChapters: 420,
    views: 9800000,
    updatedAt: '2025-02-08',
    featured: true,
    tags: ['经典国漫', '前世今生', '唯美', '感人'],
  },
  {
    id: 'comic-4',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: '韩漫',
    genres: ['奇幻', '悬疑', '冒险'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20viewpoint%20style%20apocalyptic%20fantasy%20cover%20art%2C%20young%20man%20with%20book%20in%20ruined%20city%2C%20constellation%20sky%2C%20mysterious%20atmosphere%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '独子是一名普通的上班族，唯一的爱好是阅读一部名为《在灭亡世界存活的三方法》的网络小说。当这部小说完结的那天，小说中的末日场景竟在现实中上演了。',
    fullDescription: '金独子是一个再普通不过的上班族，他唯一的兴趣爱好，就是阅读一部名为《在灭亡世界存活的三方法》的网络小说。这部小说连载了十年，他是全世界唯一的忠实读者。在小说最终话发布的那天，小说中描绘的末日场景竟然真实上演了——而他，成了这个世界上唯一知道故事结局的人。凭借对剧情的了解，金独子必须在真实的上演中生存下去。这是一部设定极其新颖的韩漫，将"读者"与"故事"的边界打破，剧情反转不断，世界观宏大而细腻。',
    rating: 9.6,
    status: '连载中',
    totalChapters: 210,
    views: 11500000,
    updatedAt: '2025-01-30',
    featured: true,
    tags: ['神作', '反套路', '末世', '智力战'],
  },
  {
    id: 'comic-5',
    title: '间谍过家家',
    author: '远藤达哉',
    category: '日漫',
    genres: ['搞笑', '治愈', '动作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20spy%20family%20style%20comedy%20cover%20art%2C%20family%20of%20three%20with%20spy%20father%20assassin%20mother%20telepath%20child%2C%20warm%20colorful%20tone%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '为了执行秘密任务"枭"，顶级间谍黄昏需要在七天内组建一个临时家庭。他找来的"女儿"是能读心的超能力者，"妻子"则是暗杀者——三人各怀秘密，却开始了奇妙的家庭生活。',
    fullDescription: '为了潜入名校接近目标人物，西国最强间谍"黄昏"奉命在七天内组建一个临时家庭。他领养了孤儿院的小女孩阿尼亚——但她其实是一个能读心的超能力者。他又找来了公务员约尔假扮妻子——而她其实是代号"睡美人"的职业杀手。于是，一个各怀秘密的临时家庭诞生了：间谍父亲、杀手母亲、读心女儿。虽然他们的相遇始于谎言，但在日常的点滴相处中，真正的亲情逐渐萌芽。《间谍过家家》以温暖幽默的笔触，讲述了一个关于"家"的动人故事，在全球范围引发热潮。',
    rating: 9.4,
    status: '连载中',
    totalChapters: 103,
    views: 18200000,
    updatedAt: '2025-02-15',
    featured: true,
    tags: ['全球热', '温馨', '搞笑', '家庭'],
  },
  {
    id: 'comic-6',
    title: '镖人',
    author: '许先哲',
    category: '国漫',
    genres: ['热血', '动作', '古风'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20blades%20of%20the%20guardians%20style%20martial%20arts%20historical%20cover%20art%2C%20fierce%20warrior%20with%20sword%20in%20desert%2C%20ancient%20China%20rough%20ink%20style%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '大业三年，隋王朝在隋炀帝杨广的暴政下风雨飘摇。身手不凡的镖客刀马行走于西域大漠，在乱世中守护着心中信念。一部充满江湖气息的硬派武侠国漫。',
    fullDescription: '大业三年（公元607年），隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马带着小七，行走于西域大漠之中。他接受各种委托，在乱世中谋生。然而，一桩看似简单的护镖任务，却将他卷入了朝廷与江湖的巨大漩涡。刀马不仅要面对各路高手的追杀，更要守护自己心中的侠义。《镖人》以粗犷豪放的画风、硬朗扎实的分镜，被誉为"中国漫画的里程碑"，甚至受到日本漫画界的盛赞。它是一部真正意义上的硬派武侠漫画，展现了国漫的最高水准。',
    rating: 9.5,
    status: '连载中',
    totalChapters: 118,
    views: 7600000,
    updatedAt: '2024-11-20',
    featured: false,
    tags: ['硬核', '武侠', '历史', '国漫之光'],
  },
  {
    id: 'comic-7',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    category: '韩漫',
    genres: ['恋爱', '奇幻', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20fantasy%20princess%20style%20cover%20art%2C%20beautiful%20princess%20with%20blonde%20hair%20in%20elegant%20dress%2C%20royal%20palace%20aesthetic%2C%20sparkle%20magic%20effects%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '一觉醒来，我变成了小说中注定被亲生父亲杀死的悲惨公主。为了避免悲惨结局，我决定用尽一切办法活下来，却不料冰山父皇竟逐渐被融化……',
    fullDescription: '一觉醒来，发现自己穿越进了睡前读的那本小说里，成为了注定被亲生父亲——冷酷无情的皇帝克劳德——杀死的公主阿塔娜西娅。按照原著剧情，她将在18岁生日那天被父亲处死。为了改变命运，阿塔娜西娅决定主动接近这个可怕的父皇，用尽撒娇卖萌的本领。然而，当冰山般的父亲逐渐被她融化、甚至开始对她展现出从未有过的温柔时，阿塔娜西娅才发现，改写命运并不是她想象中那么简单。这部漫画画风精美绝伦，父女亲情的描绘感人至深，是韩漫中不可错过的经典之作。',
    rating: 9.2,
    status: '已完结',
    totalChapters: 125,
    views: 8900000,
    updatedAt: '2024-09-10',
    featured: false,
    tags: ['穿越', '父女', '治愈', '画风精美'],
  },
  {
    id: 'comic-8',
    title: '进击的巨人',
    author: '谏山创',
    category: '日漫',
    genres: ['热血', '悬疑', '动作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20attack%20on%20titan%20style%20dark%20fantasy%20cover%20art%2C%20giant%20titan%20looming%20over%20walls%2C%20soldiers%20with%20blades%2C%20dramatic%20epic%20atmosphere%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '人类生活在被巨人包围的高墙之内。少年艾伦·耶格尔目睹母亲被巨人吞噬后，发誓要消灭所有巨人。然而，墙外的真相远比想象中更加残酷和复杂。',
    fullDescription: '107年前，世界上突然出现了人类的天敌——巨人。幸存的人类逃到了一个地方，筑起了三道巨大的高墙，在墙内度过了一百多年的和平生活。少年艾伦·耶格尔向往墙外的世界，却目睹了母亲被巨人吞噬的惨剧。满怀复仇之心的他，加入了调查兵团，立志要将巨人一匹不剩地驱逐出去。然而，随着真相一层层揭开，艾伦发现这个世界的残酷远超他的想象。《进击的巨人》以其宏大的世界观、深刻的政治隐喻和惊人的剧情反转，成为了21世纪最具影响力的漫画作品之一。',
    rating: 9.6,
    status: '已完结',
    totalChapters: 139,
    views: 22000000,
    updatedAt: '2024-04-05',
    featured: false,
    tags: ['神作', '史诗', '反转', '暗黑'],
  },
  {
    id: 'comic-9',
    title: '一人之下',
    author: '米二',
    category: '国漫',
    genres: ['热血', '都市', '搞笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20the%20outcast%20style%20supernatural%20urban%20cover%20art%2C%20young%20man%20with%20mysterious%20power%20in%20modern%20city%2C%20Taoist%20elements%2C%20dynamic%20energy%20effects%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '普通大学生张楚岚因爷爷的尸体被盗，卷入了一个名为"异人"的隐秘世界。在这里，他遇见了神秘少女冯宝宝，从此踏上了追寻真相的冒险之旅。',
    fullDescription: '普通大学生张楚岚某天接到通知——爷爷的坟被人刨了。为了追查真相，他回到老家，却遇到了一个自称是他"姐姐"的神秘少女冯宝宝。随着调查深入，张楚岚逐渐了解到爷爷的真实身份以及隐藏在普通世界背后的"异人"世界。在这个充满道术、气功和各种异术的世界里，张楚岚成为了各方势力争夺的焦点。《一人之下》完美融合了中国传统文化与现代都市背景，世界观宏大，角色塑造极为鲜活，被誉为国漫排行榜的常青树。',
    rating: 9.3,
    status: '连载中',
    totalChapters: 650,
    views: 13500000,
    updatedAt: '2025-02-10',
    featured: false,
    tags: ['国漫之光', '道家', '都市', '悬疑'],
  },
  {
    id: 'comic-10',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: '日漫',
    genres: ['热血', '奇幻', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20demon%20slayer%20style%20cover%20art%2C%20young%20swordsman%20with%20green%20checkered%20haori%2C%20water%20breathing%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '大正时代，少年灶门炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人的方法，炭治郎踏上了成为鬼杀队剑士的道路。',
    fullDescription: '大正时代，卖炭为生的善良少年灶门炭治郎，某日回家发现全家惨遭鬼的杀害。唯一幸存的妹妹祢豆子虽然还有体温，却已经变成了鬼。为了让妹妹变回人类，也为了向杀害家人的鬼复仇，炭治郎踏上了成为鬼杀队剑士的道路。他背负着妹妹这个既是家人又是鬼的矛盾存在，在残酷的战斗中不断成长，用温柔和坚强感化着身边的人。《鬼灭之刃》以极其细腻的情感刻画和震撼的战斗场面，创造了日本漫画史上的销量神话，是一部真正触动人心的作品。',
    rating: 9.4,
    status: '已完结',
    totalChapters: 205,
    views: 25000000,
    updatedAt: '2024-06-15',
    featured: false,
    tags: ['现象级', '兄妹', '感人', '战斗'],
  },
  {
    id: 'comic-11',
    title: '女神降临',
    author: 'Yaongyi',
    category: '韩漫',
    genres: ['恋爱', '校园', '搞笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20true%20beauty%20style%20romance%20school%20comedy%20cover%20art%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20high%20school%20drama%2C%20soft%20pink%20color%20tone%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '因外貌被霸凌的女高中生林周京，通过化妆技巧华丽变身成为校园女神。在两个截然不同的生活中周旋，她遇见了两个知道她素颜秘密的男生……',
    fullDescription: '林周京从小因为外貌不出众而遭受霸凌，被同学嘲笑和排挤。进入高中后，她决心改变自己——通过在网上学习的化妆技巧，她成功实现了惊人的"换头"变身，成为了新学校的女神。然而，表面的光鲜亮丽之下，她每天都活在素颜被发现的恐惧之中。更麻烦的是，学校里最受欢迎的两个男生——高冷学霸李修浩和阳光暖男韩书俊——都知道了她的秘密。这部韩漫以轻松幽默的方式探讨了外貌焦虑、自我认同等深刻话题，画风精致，角色魅力十足。',
    rating: 9.0,
    status: '已完结',
    totalChapters: 226,
    views: 10500000,
    updatedAt: '2024-08-20',
    featured: false,
    tags: ['变身', '校园', '爱情', '人气'],
  },
  {
    id: 'comic-12',
    title: '大理寺日志',
    author: 'RC',
    category: '国漫',
    genres: ['搞笑', '悬疑', '古风'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20white%20cat%20legend%20style%20historical%20comedy%20cover%20art%2C%20white%20cat%20official%20in%20Tang%20dynasty%20costume%2C%20ancient%20Chinese%20palace%2C%20funny%20contrast%2C%20clean%20simple%20background%2C%20anime%20style%20illustration&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '唐朝武周时期，洛阳大理寺迎来了一位特别的新任少卿——一只会说话的白猫李饼。他与下属陈拾一起，在诡异案件中揭开层层迷雾。',
    fullDescription: '唐朝武周年间，洛阳大理寺中有一只特别的白猫——他是新任大理寺少卿李饼。李饼本是李唐皇室后裔，因某种原因变成了猫的形态，但他依然以超凡的智慧统领大理寺，处理各种诡异的案件。来自乡下的朴实青年陈拾阴差阳错成为了李饼的下属，两人（一人一猫）在笑料百出的日常中，侦破了一系列离奇案件。这部国漫将历史背景、悬疑推理与幽默元素巧妙结合，画风独特、故事节奏极佳，是不可多得的国产漫画精品。',
    rating: 9.1,
    status: '连载中',
    totalChapters: 280,
    views: 6200000,
    updatedAt: '2025-01-10',
    featured: false,
    tags: ['历史', '推理', '搞笑', '猫'],
  },
];

export const rankings = {
  hot: ['comic-1', 'comic-2', 'comic-3', 'comic-5', 'comic-10', 'comic-8', 'comic-4', 'comic-9', 'comic-6', 'comic-7'],
  new: ['comic-5', 'comic-2', 'comic-3', 'comic-4', 'comic-9', 'comic-12', 'comic-6', 'comic-11', 'comic-7', 'comic-1'],
  rating: ['comic-1', 'comic-4', 'comic-8', 'comic-2', 'comic-6', 'comic-10', 'comic-5', 'comic-3', 'comic-9', 'comic-7'],
};

export const faqs = [
  {
    question: '香蕉漫画是什么？',
    answer: '香蕉漫画是一个专注于韩漫、日漫、国漫推荐的中文漫画导航平台。我们精选各类热门漫画，为漫迷提供高清漫画免费在线阅读推荐、人气排行榜和分类浏览服务，帮助漫迷快速找到自己喜欢的漫画作品。',
  },
  {
    question: '网站上的漫画如何分类？',
    answer: '我们将漫画分为三大类：韩漫（韩国漫画，画风精美，擅长恋爱、奇幻题材）、日漫（日本漫画，类型最丰富，产业链最成熟）、国漫（国产漫画，近年迅速崛起，原创佳作频出）。每个大类下又按风格分为恋爱、奇幻、热血、悬疑、搞笑、都市、古风、校园、冒险、治愈、科幻、动作等多个子分类。',
  },
  {
    question: '香蕉漫画是否需要收费？',
    answer: '香蕉漫画作为漫画推荐平台完全免费。我们为漫迷提供详细的漫画介绍、评分和推荐理由，帮助您发现优质漫画。具体漫画的阅读可能跳转至对应正版平台，请您支持正版漫画。',
  },
  {
    question: '如何找到自己想看的漫画？',
    answer: '您可以通过以下方式找到心仪的漫画：1）在首页浏览热门推荐和排行榜；2）进入分类页面，按韩漫/日漫/国漫和风格标签筛选；3）使用搜索功能查找特定漫画。每个漫画都有详细的介绍和评分供您参考。',
  },
  {
    question: '排行榜是如何计算的？',
    answer: '我们的排行榜综合了多个维度：人气热度（浏览量）、读者评分、更新频率和社会讨论度。我们会在首页展示热门榜、新作榜和评分榜三个榜单，帮助您全方位了解当前最受欢迎的漫画作品。',
  },
  {
    question: '网站上的漫画信息多久更新一次？',
    answer: '我们的编辑团队会每日追踪漫画更新动态，确保推荐信息及时准确。热门漫画的更新状态、最新章节等信息会实时同步，让漫迷不错过任何精彩内容。',
  },
];